import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Line-by-line masked reveal. Parent drives the viewport trigger so the
// translated child never falls outside the observer box.
export const MaskText = ({ lines = [], className = "", delay = 0, stagger = 0.12, once = true }) => (
  <motion.span
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once, amount: 0.1 }}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em]">
        <motion.span
          className="block"
          variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
          transition={{ duration: 1.05, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

// On-load version (no scroll trigger) for hero.
export const MaskTextLoad = ({ lines = [], className = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, className = "", delay = 0, y = 36, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.2 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", delayChildren = 0, stagger = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.15 }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger, delayChildren } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);
